import ByteBitSet from "./char_bit_set.js";
import { encodeCharacter, encodeToken } from "./token_parsing.js";
const whiteSpaceBuffer = encodeToken(" \t\r\n");
const whitespaceSet = new ByteBitSet();
whitespaceSet.set(whiteSpaceBuffer);
const commaEndBracketBuffer = encodeToken(",)");
const commaEndBracketSet = new ByteBitSet();
commaEndBracketSet.set(commaEndBracketBuffer);
/**
 * Constants to be used for parsing value or STEP.
 */
export default class ParsingConstants {
}
ParsingConstants.SPACE = encodeCharacter(" ");
ParsingConstants.STAR = encodeCharacter("*");
ParsingConstants.SLASH = encodeCharacter("/");
ParsingConstants.TAB = encodeCharacter("\t");
ParsingConstants.NEWLINE = encodeCharacter("\n");
ParsingConstants.HASH = encodeCharacter("#");
ParsingConstants.OPEN_PAREN = encodeCharacter("(");
ParsingConstants.CLOSE_PAREN = encodeCharacter(")");
ParsingConstants.COMMA = encodeCharacter(",");
ParsingConstants.DOLLAR = encodeCharacter("$");
ParsingConstants.COLON = encodeCharacter(";");
ParsingConstants.SEMICOLON = encodeCharacter(";");
ParsingConstants.BSLASH = encodeCharacter("\\");
ParsingConstants.ZERO = encodeCharacter("0");
ParsingConstants.NINE = encodeCharacter("9");
ParsingConstants.SIGN = encodeCharacter("-");
ParsingConstants.PLUS = encodeCharacter("+");
ParsingConstants.SIGN_NUM = ParsingConstants.SIGN - ParsingConstants.ZERO;
ParsingConstants.PLUS_NUM = ParsingConstants.PLUS - ParsingConstants.ZERO;
ParsingConstants.DOT = encodeCharacter(".");
ParsingConstants.DOT_NUM = ParsingConstants.DOT - ParsingConstants.ZERO;
ParsingConstants.CAPITAL_X = encodeCharacter("X");
ParsingConstants.CAPITAL_S = encodeCharacter("S");
ParsingConstants.CAPITAL_P = encodeCharacter("P");
ParsingConstants.LOWER_CASE_X = encodeCharacter("x");
ParsingConstants.A = encodeCharacter("A");
ParsingConstants.a = encodeCharacter("a");
ParsingConstants.I = encodeCharacter("I");
ParsingConstants.Z = encodeCharacter("Z");
ParsingConstants.F = encodeCharacter("F");
ParsingConstants.LOWER_A = encodeCharacter("a");
ParsingConstants.LOWER_Z = encodeCharacter("z");
ParsingConstants.LOWER_F = encodeCharacter("f");
ParsingConstants.E = encodeCharacter("E");
ParsingConstants.LOWER_E = encodeCharacter("e");
ParsingConstants.UNDERSCORE = encodeCharacter("_");
ParsingConstants.EQUALS = encodeCharacter("=");
ParsingConstants.QUOTE = encodeCharacter("'");
ParsingConstants.DOUBLEQUOTE = encodeCharacter("\"");
ParsingConstants.DASH = encodeCharacter("-");
ParsingConstants.WHITE_SPACE = whiteSpaceBuffer;
ParsingConstants.WHITE_SPACE_SET = whitespaceSet;
ParsingConstants.COMMA_END_BRACE = commaEndBracketBuffer;
ParsingConstants.COMMA_END_SET = commaEndBracketSet;
